"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _order = require("@/api/order");
var _permission = require("@/utils/permission");
var _filters = require("@/filters");
var _LogisticsModal = _interopRequireDefault(require("@/components/OrderDetail/LogisticsModal.vue"));
var _SupplierAfterSalesPanel = _interopRequireDefault(require("./SupplierAfterSalesPanel.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default = exports.default = {
  name: 'refundOrderDetail',
  props: {
    //退款单号
    refundOrderNo: {
      type: String,
      default: 0
    },
    //是否显示隐藏
    drawerVisible: {
      type: Boolean,
      default: false
    }
  },
  components: {
    LogisticsModal: _LogisticsModal.default,
    SupplierAfterSalesPanel: _SupplierAfterSalesPanel.default
  },
  data: function data() {
    return {
      dialogVisible: false,
      loadingBtn: false,
      activeName: 'refund',
      direction: 'rtl',
      reverse: true,
      orderDatalist: {},
      loading: false,
      modal2: false,
      result: [],
      expressName: '',
      // 快递公司
      trackingNumber: '',
      // 快递单号
      resultInfo: {},
      // 物流详细信息
      refundInfo: {},
      offlineRefundDialogVisible: false,
      offlineRefundSubmitting: false,
      offlineRefundForm: {
        refundOrderNo: '',
        refundAmount: undefined,
        paymentProof: ''
      },
      offlineRefundRules: {
        refundAmount: [{
          required: true,
          message: '请填写退款金额',
          trigger: 'blur'
        }],
        paymentProof: [{
          required: true,
          message: '请上传付款凭证',
          trigger: 'change'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.getRefundOrderDetail(this.refundOrderNo);
  },
  methods: {
    checkPermi: _permission.checkPermi,
    isOfflineRefundOrder: function isOfflineRefundOrder(refundInfo) {
      if (!refundInfo) return false;
      var hasOfflineResult = !!(refundInfo.offlineRefundAmount || refundInfo.offlineRefundProof);
      if (refundInfo.refundStatus === 3) {
        return hasOfflineResult;
      }
      return hasOfflineResult || !!refundInfo.customerServiceContact;
    },
    getOfflineRefundProofList: function getOfflineRefundProofList(proof) {
      var _this = this;
      if (!proof) return [];
      return String(proof).split(',').map(function (item) {
        return _this.normalizeImageUrl(item);
      }).filter(Boolean);
    },
    normalizeImageUrl: function normalizeImageUrl(url) {
      if (!url) return '';
      var value = String(url).trim().replace(/\\/g, '/').replace(/^(https?:)\/(?!\/)/i, '$1//');
      var protocolReg = /https?:\/\//gi;
      var match;
      var lastProtocolIndex = -1;
      var protocolCount = 0;
      while (match = protocolReg.exec(value)) {
        protocolCount += 1;
        lastProtocolIndex = match.index;
      }
      if (protocolCount > 1) {
        value = value.slice(lastProtocolIndex);
      }
      return value;
    },
    normalizeOfflineRefundUploadValue: function normalizeOfflineRefundUploadValue(file) {
      var value = this.normalizeImageUrl(file && (file.attDir || file.sattDir || file.url || file));
      var imagePathIndex = value.indexOf('/crmebimage/');
      if (imagePathIndex >= 0) {
        return value.slice(imagePathIndex + 1);
      }
      return value;
    },
    handleClose: function handleClose() {
      this.$emit('onClosedrawerVisible');
    },
    // 备注
    onOrderMark: function onOrderMark() {
      var _this2 = this;
      this.$modalPrompt('textarea', '退款单备注', this.refundInfo.platformRemark).then(function (V) {
        (0, _order.refundMarkApi)({
          remark: V,
          refundOrderNo: _this2.refundOrderNo
        }).then(function () {
          _this2.$message.success('操作成功');
        });
      });
    },
    // 获取订单退款信息
    getRefundOrderDetail: function getRefundOrderDetail(id) {
      var _this3 = this;
      this.loading = true;
      (0, _order.refundOrderDetailApi)(id).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                _this3.refundInfo = res;
                _this3.loading = false;
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function () {
        _this3.loading = false;
      });
    },
    handlerCompulsoryReturn: function handlerCompulsoryReturn(refundInfo) {
      var _this4 = this;
      this.$confirm("\u786E\u5B9A\u5F3A\u5236\u9000\u6B3E\u3010".concat(refundInfo.refundPrice, "\u3011 \u9000\u6B3E\u5355\uFF0C\u6B64\u64CD\u4F5C\u4E0D\u53EF\u9006\uFF0C\u8BF7\u614E\u91CD\u786E\u8BA4\u540E\u518D\u64CD\u4F5C"), '强制退款提示').then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var result;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return (0, _order.orderRefundCompulsoryApi)(refundInfo.refundOrderNo);
            case 1:
              result = _context2.v;
              _this4.$emit('compulsoryReturnSuccess');
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      })));
    },
    openOfflineRefundDialog: function openOfflineRefundDialog() {
      var _this5 = this;
      this.offlineRefundForm = {
        refundOrderNo: this.refundInfo.refundOrderNo,
        refundAmount: Number(this.refundInfo.refundPrice || 0),
        paymentProof: ''
      };
      this.offlineRefundDialogVisible = true;
      this.$nextTick(function () {
        _this5.$refs.offlineRefundFormRef && _this5.$refs.offlineRefundFormRef.clearValidate();
      });
    },
    selectOfflineRefundProof: function selectOfflineRefundProof() {
      var _this6 = this;
      this.$modalUpload(function (img) {
        var first = Array.isArray(img) ? img[0] : img;
        _this6.offlineRefundForm.paymentProof = _this6.normalizeOfflineRefundUploadValue(first);
        _this6.$nextTick(function () {
          _this6.$refs.offlineRefundFormRef && _this6.$refs.offlineRefundFormRef.validateField('paymentProof');
        });
      }, false);
    },
    submitOfflineRefund: function submitOfflineRefund() {
      var _this7 = this;
      this.$refs.offlineRefundFormRef.validate(function (valid) {
        if (!valid) return;
        _this7.offlineRefundSubmitting = true;
        (0, _order.orderOfflineRefundCompleteApi)(_this7.offlineRefundForm).then(function () {
          _this7.$message.success('操作成功');
          _this7.offlineRefundDialogVisible = false;
          _this7.getRefundOrderDetail(_this7.refundOrderNo);
          _this7.$emit('compulsoryReturnSuccess');
        }).finally(function () {
          _this7.offlineRefundSubmitting = false;
        });
      });
    },
    // 查看物流信息
    openLogistics: function openLogistics(expressName, telephone, trackingNumber) {
      var _this8 = this;
      this.expressName = expressName;
      this.trackingNumber = trackingNumber;
      this.resultInfo = {};
      this.$refs.logisticsModalRef.open();
      var data = {
        expressName: expressName,
        telephone: telephone,
        trackingNumber: trackingNumber
      };
      (0, _order.getRefundOrderLogisticsInfoApi)(data).then(function (res) {
        _this8.resultInfo = res || {};
      }).catch(function (err) {
        console.log('订单物流获取失败：', err);
      });
    }
  }
};